import script from "./form-page-tab-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-page-tab-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./form-page-tab-wrap.vue?vue&type=style&index=0&id=7c8cbf6e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8cbf6e"]])

export default __exports__